export default __webpack_public_path__ + "static/media/ftmgdeliZLP.449aaac7.png";